import { Component, OnInit, OnChanges, ChangeDetectorRef, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';
import { TarjetasService, consultaAbtResp } from 'src/app/service/tarjetas.service';

@Component({
  selector: 'app-movimientos',
  templateUrl: './movimientos.component.html',
  styleUrls: ['./movimientos.component.scss'],
})
export class MovimientosComponent implements OnInit {
  cardSelected: any;
  filter: any;
  errorMensaje: any;
  count = 0;
  transacciones: Subscription;
  tarjeta: Subscription;
  gettingData: boolean = false;
  movimientos: consultaAbtResp = {
    mensaje: '',

    saldo: undefined,
    estadoVigencia: '',
    listaTransacciones: []
  }

  constructor(private router: Router, private tarjetas: TarjetasService, private cd: ChangeDetectorRef) {
    this.movimientos.mensaje = '';

  }


  ngOnInit() {

    this.tarjeta = this.tarjetas.selectedCard.pipe().subscribe(tarjetas => {
      this.count++
      this.cardSelected = tarjetas;
      this.filter = 30;
      this.getData();
    });

  }

  changeFilter(value) {
    this.filter = value;
    this.getData();
  }
  getData() {

    let json = {
      "tipoConsulta": 2,
      "numExterno": this.cardSelected,
      "numInterno": localStorage.getItem('numInt'),
      "numeroDias": this.filter,
      "nivelConsulta": 2
    }

    if (!this.gettingData) {

      this.gettingData = true
      this.transacciones = this.tarjetas.getTransaccionesAbt(json).pipe(debounceTime(1000)).subscribe(
        (res: consultaAbtResp) => {
          this.movimientos = res;
          this.gettingData = false
        })

    }

  }

  monto(data: any) {
    return (data.MONTO_ABONO == 0) ? "$" + data.MONTO_DESCUENTO : "$" + data.MONTO_ABONO;
  }

  comproboTrx(data) {
    if (data.codigotipotrx != 15) {
      return data.estacion
    }

    if (data.servicio == null) {
      return data.estacion
    }

    return data.servicio
  }
  comproboVehi(data) {
    if (data.codigotipotrx != 15) {
      return null
    }

    if (data.servicio == null) {
      return null
    }

    return data.estacion
  }

  ngOnDestroy() {
    this.transacciones.unsubscribe();
    this.tarjeta.unsubscribe();
  }
}


